var map = {
	"./button_anotovanie.svg": "457a",
	"./button_circle_download.svg": "02ee",
	"./button_close_info.svg": "d3c4",
	"./button_delete_anots.svg": "9444",
	"./button_delete_close_x.svg": "d349",
	"./button_delete_highlights.svg": "af6f",
	"./button_delete_icon.svg": "1234",
	"./button_delete_template.svg": "e4f0",
	"./button_double_chevron_left.svg": "7b00",
	"./button_double_chevron_right.svg": "fe56",
	"./button_download.svg": "bc11",
	"./button_home.svg": "9d2a",
	"./button_info_questionmark.svg": "9cb1",
	"./button_list.svg": "d33b",
	"./button_locked_document.svg": "cce0",
	"./button_obnovenie.svg": "8ef0",
	"./button_prefix_off.svg": "1e14",
	"./button_prefix_on.svg": "6c4e",
	"./button_presnaZhoda_off.svg": "d3dc",
	"./button_presnaZhoda_on.svg": "057f5",
	"./button_save.svg": "4714",
	"./button_suffix_off.svg": "59d7",
	"./button_suffix_on.svg": "a43a",
	"./button_trash.svg": "f4dc",
	"./button_unlocked_document.svg": "a4c8",
	"./button_volna_an.svg": "8b4a",
	"./circle-check-regular.svg": "0382",
	"./clock-regular.svg": "0195",
	"./icon_documents.svg": "b12e",
	"./icon_error.svg": "361b",
	"./icon_ok.svg": "e5ad",
	"./icon_upload.svg": "9c8a",
	"./icon_warning.svg": "1518"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";